import xhttp from 'src/utils/xhttp'

export function createPlatform(params) {
    const { webappId, ...rest } = params
    return xhttp.post(`webapi/wx/webapp/${webappId}/platform/create`, rest)
}

export function getPlatformInfo(params) {
    const { id: webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/platform`)
}

export function savePlatformInfo(params) {
    const { webappId, ...rest } = params
    return xhttp.put(`webapi/wx/webapp/${webappId}/platform`, rest)
}

export function getAuthorityUrl(params) {
    const { webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/authority-url`)
}

export function getWxTemplateList(params) {
    const { webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/template-list`)
}

export function useTemplate(params) {
    const { webappId } = params
    return xhttp.post(`webapi/wx/webapp/${webappId}/use-template`, params)
}

export function getDomains(params) {
    const { webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/domains`)
}

export function resetDomains(params) {
    const { webappId, ...rest } = params
    return xhttp.put(`webapi/wx/webapp/${webappId}/domains`, rest)
}

export function getDomainCounts(params) {
    const { webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/domainCounts`)
}

export function getConfig(params) {
    const { webappId } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/config`)
}

export function setConfig(params) {
    const { webappId, ...rest } = params
    return xhttp.put(`webapi/wx/webapp/${webappId}/config`, rest)
}

export function getPages(params) {
    const { webappId, miniprogramId } = params
    return xhttp.get(
        `webapi/wx/webapp/${webappId}/miniprogram/${miniprogramId}/pages`
    )
}

export function getCategory(params) {
    const { webappId, miniprogramId } = params
    return xhttp.get(
        `webapi/wx/webapp/${webappId}/miniprogram/${miniprogramId}/category`
    )
}

export function SubmitAudit(params) {
    const { webappId, ...rest } = params
    return xhttp.post(`webapi/wx/webapp/${webappId}/submit`, rest)
}

export function getMiniProgramList(params) {
    const { webappId, ...rest } = params
    return xhttp.get(`webapi/wx/webapp/${webappId}/miniprogram`, {
        params: rest
    })
}

export function getTicket(params) {
    return xhttp.get('/api/dev/paas/getWxTicket', {
        params
    })
}
